import moment from 'moment';
import type {UserAttributes} from '@api/user/api.d';

export interface PreferenceReminderSchedule {
    start_delay: number;
    interval: number;
    count: number;
}

export interface PreferenceDefaults {
    expiresAt: string | null;
    fontSize: number | null;
    reminderSchedule: PreferenceReminderSchedule | null;
    isSigningOrderEnabled: boolean;
    isChangeSignerEnabled: boolean;
}

const EMPTY_DEFAULTS: PreferenceDefaults = {
    expiresAt: null,
    fontSize: null,
    reminderSchedule: null,
    isSigningOrderEnabled: false,
    isChangeSignerEnabled: false
};

export function getPreferenceDefaults(userAttributes: Partial<UserAttributes> | null | undefined): PreferenceDefaults {
    if (!userAttributes) {
        return EMPTY_DEFAULTS;
    }

    const hasAutoExpire = Boolean(userAttributes.enable_auto_expire) && Number(userAttributes.auto_expire_days) > 0;
    const expiresAt = hasAutoExpire
        ? moment().add(Number(userAttributes.auto_expire_days), 'days').toISOString()
        : null;

    const hasFontSize = Boolean(userAttributes.enable_fontsize);
    const fontSize = hasFontSize && userAttributes.default_fontsize !== undefined
        ? Number(userAttributes.default_fontsize)
        : null;

    const reminderSchedule = userAttributes.enable_reminder_schedule
        ? {
            start_delay: Number(userAttributes.reminder_schedule_first_reminder),
            interval: Number(userAttributes.reminder_schedule_interval_in_days),
            count: Number(userAttributes.reminder_schedule_max_reminders)
        }
        : null;

    return {
        expiresAt,
        fontSize,
        reminderSchedule,
        isSigningOrderEnabled: Boolean(userAttributes.enable_signing_order),
        isChangeSignerEnabled: Boolean(userAttributes.allow_change_signer)
    };
}
